import { Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Rollen-Schranke für den Verwaltungsbereich.
 *
 * Zwei Dinge, die hier leicht falsch gemacht werden:
 *
 * Erstens wird über **Rollen** geprüft, nicht über Capabilities. Ein
 * menschlicher Aufrufer bekommt vom Server immer dieselben drei Capabilities;
 * `fleet:manage` ist nicht darunter, auch nicht für Administratoren.
 *
 * Zweitens ist das reine Darstellung. Die eigentliche Prüfung passiert bei jedem
 * einzelnen Aufruf im Server — eine Oberfläche, die einen Menüpunkt ausblendet,
 * hat noch nichts abgesichert.
 */
export function RequireRole({ roles }: { roles: string[] }) {
  const auth = useAuth();

  if (auth.isLoading) return <p className="text-sm text-slate-500">Wird geladen …</p>;

  if (!roles.some((role) => auth.hasRole(role))) {
    return (
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-6">
        <h2 className="text-sm font-medium text-amber-900">Kein Zugriff auf die Verwaltung</h2>
        <p className="mt-2 text-sm leading-relaxed text-amber-800">
          Dieser Bereich ist der Fuhrparkleitung und Administratoren vorbehalten.
          {auth.me?.roles.length === 0 &&
            ' Dein Konto hat derzeit keine zugewiesene Rolle — für das Buchen ist das in Ordnung, für die Verwaltung nicht.'}
        </p>
      </div>
    );
  }

  return <Outlet />;
}
